<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório estatístico por status">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-estatistico-status/List'

export default {
    components: {List},
}
</script>